import { Conditional, ConfirmationModal } from 'iq-blueberry'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Img from '../Img'
import ModalOneButton from '../ModalOneButton'
import Loader from 'components/common/Loader'

import TakePictureButton from './TakePictureButton'
import useCamera from './hook'

import './style.styl'
import { usePicture } from './hooks/usePicture'
import { useTexts } from './hooks/useTexts'
import { PictureConfirmation } from './PictureConfirmation'

const Camera = ({
  showMask = false,
  maskType,
  facing = 'user',
  format = 'png',
  reviewImageTitle,
  reviewImageText,
  onTakePicture,
  outputType = 'dataURL',
  closeStreamOnTakePicture = false,
  hasCameraAllowedState,
  setShouldOpenCamera,
  displayCloseButton = true,
  optimized,
}) => {
  const {
    videoRef,
    stream,
    isEnvironmentCamera,
    showTakePictureButton,
    handleCamera,
    handleReopenCamera,
    _closeStreamTracks,
  } = useCamera({
    facing,
    setShouldOpenCamera,
  })

  const {
    imagePath,
    shouldOpenPictureReview,
    handleTakePicture,
    handleTakeOtherPhoto,
    handleUseThisPhoto,
  } = usePicture({
    isEnvironmentCamera,
    videoRef,
    format,
    outputType,
    onTakePicture,
    _closeStreamTracks,
    handleReopenCamera,
  })

  const { maskText, componentClass } = useTexts(isEnvironmentCamera)

  if (shouldOpenPictureReview) {
    return (
      <Conditional
        condition={optimized}
        renderIf={
          <PictureConfirmation
            imagePath={imagePath}
            title={reviewImageTitle}
            description={reviewImageText}
            handleContinue={handleUseThisPhoto}
            handleTakeOtherPhoto={handleTakeOtherPhoto}
          />
        }
        renderElse={
          <div className="app-camera-modal">
            <div className={classNames('image-preview', `-${facing}`)}>
              {imagePath ? (
                <img src={imagePath} alt="Upload review" />
              ) : (
                <Loader />
              )}
            </div>

            {imagePath && (
              <ConfirmationModal
                title={reviewImageTitle}
                text={reviewImageText}
                buttonText="Continuar"
                dangerButtonText="Tirar outra foto"
                hasOverlay={false}
                hasCloseButton={false}
                isActive={true}
                handleDangerButton={handleTakeOtherPhoto}
                handleButton={handleUseThisPhoto}
                hasButtons
              />
            )}
          </div>
        }
      />
    )
  }

  return (
    <div className={componentClass}>
      {stream ? (
        <>
          <div
            className={classNames(
              'app-camera__video-holder',
              `-${maskType || facing}`,
              {
                '-show-mask': showMask,
              }
            )}>
            <video
              className={classNames('app-camera__video', `-${facing}`)}
              ref={videoRef}
              autoPlay
              muted
              playsInline
            />
          </div>
          <div className="app-camera__actions">
            {showMask && (
              <p className="app-camera__warning">
                {maskText} e toque em ”<strong>Continuar</strong>”
              </p>
            )}
            {showTakePictureButton && (
              <TakePictureButton
                showLargeButton={showMask}
                onClick={handleTakePicture}
              />
            )}
          </div>
          <Conditional 
            condition={displayCloseButton} 
            renderIf={
              <button className="app-camera__close" onClick={handleCamera}>
                <Img alt="Ícone para fechar câmera" src="images/close-circle.svg" />
              </button>
            }
          />
        </>
      ) : null}
    </div>
  )
}

export default Camera
